export default "__VITE_ASSET__FvBwhkd8__"